// ImageUploadGuideModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import img1 from "../../../assets/images/packagImgUpload/img1.png";
import img2 from "../../../assets/images/packagImgUpload/img2.png";
import img3 from "../../../assets/images/packagImgUpload/img3.png";
import img4 from "../../../assets/images/packagImgUpload/img4.png";
import "./ImageUploadGuideModal.css";

const ImageUploadGuideModal = ({ show, onHide }) => {
    return (
        <Modal className="imageUploadGuide" centered show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5>Upload Packed Product Dimensions and Weight</h5>
                <div className="imgContainer">
                    <div className="imgUploadGuideImgs">
                        <img src={img1} alt="img1" />
                        <br />
                        <p className="my-1">Image 1 : Package Length</p>
                    </div>
                    <div className="imgUploadGuideImgs">
                        <img src={img2} alt="img2" />
                        <br />
                        <p className="my-1">Image 2 : Package Width</p>
                    </div>
                </div>
                <div className="imgContainer">
                    <div className="imgUploadGuideImgs">
                        <img src={img3} alt="img3" />
                        <br />
                        <p className="my-1">Image 3 : Package Height</p>
                    </div>
                    <div className="imgUploadGuideImgs">
                        <img src={img4} alt="img4" />
                        <br />
                        <p className="my-1">Image 4 : Package Weight</p>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ImageUploadGuideModal;